var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8B4FE3",
  fillRule: "evenodd",
  d: "M20.5 1.667c.634 0 1.214.36 1.494.929l4.763 9.648 10.65 1.557a1.667 1.667 0 0 1 .922 2.843l-7.705 7.505 1.819 10.603a1.667 1.667 0 0 1-2.419 1.757L20.5 31.5l-9.524 5.009a1.667 1.667 0 0 1-2.419-1.757l1.819-10.603-7.706-7.505a1.667 1.667 0 0 1 .922-2.843l10.65-1.557 4.763-9.648c.281-.569.86-.929 1.495-.929m0 5.432-3.656 7.406a1.67 1.67 0 0 1-1.253.911l-8.177 1.195 5.915 5.762c.394.383.573.935.48 1.476l-1.395 8.137 7.31-3.844a1.67 1.67 0 0 1 1.552 0l7.31 3.844-1.395-8.137a1.67 1.67 0 0 1 .48-1.476l5.915-5.762-8.177-1.195a1.67 1.67 0 0 1-1.254-.911z",
  clipRule: "evenodd"
})));
export default SvgStarOutlined;